export class FiltroJudicial{
    IdAdqui : string = '';
    Moneda : number = 0;
    Estado : number = 0;
    FechaInicio : string = "";
    FechaFin : string = "";
}